import { Injectable } from '@angular/core';
import { of, switchMap } from "rxjs";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { DocViewerActions } from "@store/doc-viewer/doc-viewer.actions";
import { documentListActions } from "@store/doc-viewer/document-list/document-list.actions";
import { DocViewerContext } from '@models/ui/doc-viewer-context-doc.model';

@Injectable()
export class DocumentListEffects {
	public loadDocumentList$ = createEffect(() => this.actions$.pipe(
			ofType(DocViewerActions.loaded),
			switchMap(() => {
				const docsStorageString = localStorage.getItem('ContextMapping');
				if (!docsStorageString) {
					return of({type: 'noop'});
				}
				const context: DocViewerContext = JSON.parse(docsStorageString);
				return of(documentListActions.listUpdated({
					newDocumentList: context.docList, 
					isExpandedResults: context.includeEmailFamiles ?? false
				}));
			})
		)
	);

	constructor(
		private actions$: Actions,
	) {
	}
}
